<div class="container-info-pay">
    <div class="logo-city">
        <img fallimg src="assets/img/citylok_logo.png" alt="Citylok logo">
    </div>
    <p class="title-confirm">¡Hola!</p>
    <p class="info-confirm">Al comprar tus entradas en el Tótem de Citylok podrás recibirlas por
        <strong>teléfono.</strong></p>
    <button class="btn-buy-event pointer-in" mat-dialog-close="true">Siguiente</button>
</div>